import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DashboardStats } from '@models/dashboard.interface';
import { ApiResponse } from '@core/interfaces/apiResponse.interfaces';

type DashboardState = {
  data: DashboardStats | null;
  loading: boolean;
  error: string | null;
};

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api_rest_url}/dashboard`;

  private readonly stateSignal = signal<DashboardState>({
    data: null,
    loading: false,
    error: null,
  });

  readonly state = this.stateSignal.asReadonly();

  async fetch(storeId: string): Promise<void> {
    this.stateSignal.update((state) => ({
      ...state,
      loading: true,
      error: null,
    }));

    try {
      const response = await firstValueFrom(
        this.http.get<ApiResponse<DashboardStats>>(`${this.apiUrl}/${storeId}`),
      );

      this.stateSignal.set({
        data: response.data ?? null,
        loading: false,
        error: null,
      });
    } catch (error: any) {
      this.stateSignal.set({
        data: null,
        loading: false,
        error: error?.error?.message ?? 'No fue posible cargar el dashboard.',
      });
    }
  }
}
